import React, { Ref, forwardRef, useImperativeHandle, useRef } from 'react';
import { FieldPropsExt } from '../../components';
import { MaskedTextField } from '../maskedText';
import { expectedZipCodeLength, isZipCodeValid } from './ZipCodeFunctions';

export interface ZipProps extends FieldPropsExt {
  value: string | null;
  validate?: boolean;
  onChange: (value: string) => void;
}

const mask = '_____';
const maskGenerator = {
  rules: new Map([['_', /\d/]]),
  generateMask: () => mask,
  keepMask: false,
};

const ZipFieldComponent: React.ForwardRefRenderFunction<
  HTMLInputElement | null,
  ZipProps
> = (props: ZipProps, ref: Ref<HTMLInputElement | null>) => {
  const { validate = false } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => inputRef?.current);

  const validationMethod = (value: string): string => {
    if (!isZipCodeValid(value, props.required ?? false)) {
      return `Please enter ${expectedZipCodeLength} digits`;
    }

    return '';
  };

  return (
    <MaskedTextField
      {...props}
      ref={inputRef}
      placeholder={mask}
      value={props.value ?? ''}
      validate={validate}
      maskGenerator={maskGenerator}
      onChange={props.onChange}
      validationMethod={validationMethod}
    />
  );
};

const ZipField = forwardRef(ZipFieldComponent);

export default ZipField;
